import api from '@/api'

export default {
  getCurrentUser(): Promise<account.TCurrent> {
    return api.get<account.TCurrent>({ url: '/common/auth/api/current' })
  },

  getPhotoUrl(address: string): Promise<string> {
    return api.get({
        url: `/Hr/Photo/api/get?email=${address}`
    })
  },

  getPhotoUrlByCodes(codes: string[]): Promise<any[]> {
      return api.post({
          url: '/Hr/Photo/api/byCodes',
          data: codes
      });
  },

  // getUser(email: string): Promise<account.User> {
  //     return api.get({
  //         url: `/api/hr/person`,
  //         params: {
  //             email,
  //         },
  //     });
  // },

  // getUserByPersonCode(personCode: string): Promise<account.User> {
  //     return api.get({
  //         url: `/api/hr/department/person`,
  //         params: {
  //             personCode,
  //         }
  //     })
  // }
}
